export enum TypePreference {
  Historique = 0,
  Affichage = 1,
  ActionsInterventions = 2,
  Actions = 3,
  RechercheDossiers = 4
}